// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__pXEFJ","aboutTitle":"About_aboutTitle__XsuBI","aboutImage":"About_aboutImage__wB5zI","aboutText":"About_aboutText__YM2lz"};